import React, { useRef, useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import styles from './BannerModal.module.css'
import { Modals } from '../../../../../../../../Contexts/ModalsContext'
import { UserAuth } from '../../../../../../../../Contexts/AuthContext'
import { UserTheme } from '../../../../../../../../Contexts/ThemeContext'

function BannerModal() {
  const { isBannerOpen, setIsBannerOpen } = Modals()
  const { theme } = UserTheme()
  const [file, setFile] = useState()
  const [image, setImage] = useState()
  const [preview, setPreview] = useState()
  const [uploadButton, setUploadButton] = useState(true)
  const fileInputRef = useRef()
  const {
    getUserData,
    userObj,
    listStorage,
    deleteImage,
    saveImage,
    setImageForm,
    imageForm,
  } = UserAuth()

  useEffect(() => {
    getUserData()
  }, [])

  useEffect(() => {
    if (image) {
      const reader = new FileReader()
      // console.log(reader)
      reader.onloadend = () => {
        setPreview(reader.result)
        setUploadButton(false)
      }
      reader.readAsDataURL(image)
    } else {
      setPreview(null)
    }
  }, [image])

  useEffect(() => {
    if (!isBannerOpen) {
      setPreview(null)
    }
  }, [isBannerOpen])

  useEffect(() => {
    if (isBannerOpen) {
      setIsBannerOpen(false)
    }
  }, [userObj.bannerImageUrl])

  if (!isBannerOpen) return null

  const handleBannerImageChange = (e) => {
    const chosenFile = e.target.files[0]
    if (chosenFile && chosenFile.type.substr(0, 5) === 'image') {
      setImage(chosenFile)
    } else {
      setImage(null)
    }

    setImageForm((imageForm) => [...imageForm, { image: e.target.files[0] }])
    listStorage(0)
  }

  const handleUploadBannerImage = () => {
    deleteImage()
    saveImage(2)
  }

  return ReactDOM.createPortal(
    <>
      <div
        className={styles.Overlay}
        onClick={() => setIsBannerOpen(false)}
        data-theme={theme}
      />
      <div className={styles.Modal} data-theme={theme}>
        <div className={styles.Header}>Upload banner picture</div>
        <div
          className={styles.Close}
          onClick={() => {
            setIsBannerOpen(false)
          }}
        >
          <div className={styles.Bar}></div>
        </div>
        <div className={styles.Menu}>
          <img
            src={!preview ? userObj.bannerImageUrl : preview}
            className={styles.Banner}
          ></img>
          <label htmlFor="" style={{ display: 'none' }}>
            Image
          </label>
          <button
            className={styles.Choose__Button}
            onClick={(e) => {
              e.preventDefault()
              fileInputRef.current.click()
            }}
          >
            Select Image
          </button>
          <input
            type="file"
            name="image"
            ref={fileInputRef}
            accept="image/*"
            value={file}
            style={{ display: 'none' }}
            className={styles.Choose__File}
            onChange={(e) => handleBannerImageChange(e)}
          />
          <button
            className={styles.Upload}
            disabled={uploadButton}
            onClick={handleUploadBannerImage}
          >
            Save
          </button>
        </div>
      </div>
    </>,
    document.getElementById('portal')
  )
}

export default BannerModal
